import React from "react";

function OrganizationBox({ organization, onClick, isSelected }) {
    return (
        <div 
            onClick={onClick} 
            className={`OrganizationBox ${isSelected ? "selected" : ""}`}
        >
            <h3>{organization.name}</h3>
            <p>Couleur: {organization.colour_theme}</p>
        </div>
    );
}

export default OrganizationBox;
